import styled from "styled-components";

import { grayScale } from "@enkor/design/colors";

export const AvatarSection = styled.section`
  padding: 10px 16px;
  border-top: 1px solid ${grayScale.main};
  border-bottom: 1px solid ${grayScale.main};

  background-color: ${grayScale[300]};

  :hover {
    cursor: pointer;
  }
`;
